var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "shareContainer", staticClass: "share-container" },
    [
      _c(
        "v-btn",
        {
          staticClass: "open-share-btn",
          staticStyle: { float: "right", "margin-top": "0" },
          attrs: { small: "", icon: "", title: _vm.$t("share.share") },
          on: {
            click: function($event) {
              return _vm.openShare()
            }
          }
        },
        [_c("v-icon", [_vm._v("share")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", persistent: true, attach: "body" },
          model: {
            value: _vm.isShareModalOpen,
            callback: function($$v) {
              _vm.isShareModalOpen = $$v
            },
            expression: "isShareModalOpen"
          }
        },
        [
          _c(
            "box",
            {
              attrs: {
                customClass: "share-modal",
                background: "white",
                closable: ""
              },
              on: {
                closed: function($event) {
                  return _vm.closeShare()
                }
              },
              model: {
                value: _vm.isShareModalOpen,
                callback: function($$v) {
                  _vm.isShareModalOpen = $$v
                },
                expression: "isShareModalOpen"
              }
            },
            [
              _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v(_vm._s(_vm.$t("share.shareLink")))
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm10: "", "d-flex": "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "file_copy",
                          readonly: "",
                          label: _vm.$t("share.share")
                        },
                        on: {
                          "click:append": function($event) {
                            return _vm.copyUrl()
                          },
                          click: function($event) {
                            return _vm.copyUrl()
                          }
                        },
                        model: {
                          value: _vm.shareUrl,
                          callback: function($$v) {
                            _vm.shareUrl = $$v
                          },
                          expression: "shareUrl"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm2: "", "d-flex": "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "toggle-short-url",
                          staticStyle: { "margin-top": "11px" },
                          attrs: { color: "primary", title: _vm.shortBtnTitle },
                          on: {
                            click: function($event) {
                              return _vm.toggleShortUrl()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.shortBtnTitle))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-alert", { attrs: { value: true, type: "info" } }, [
                _vm._v(" " + _vm._s(_vm.$t("share.copyUrlInfo")))
              ]),
              _vm._v(" "),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", "d-flex": "" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          "auto-grow": "",
                          readonly: "",
                          label: _vm.$t("share.embed")
                        },
                        on: {
                          click: function($event) {
                            return _vm.copyEmbed()
                          }
                        },
                        model: {
                          value: _vm.embedCode,
                          callback: function($$v) {
                            _vm.embedCode = $$v
                          },
                          expression: "embedCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-alert", { attrs: { value: true, type: "info" } }, [
                _vm._v(" " + _vm._s(_vm.$t("share.embedInstructions")))
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02d7058a", { render: render, staticRenderFns: staticRenderFns })
  }
}